import request from '../utils/request';
import setting from './apiSetting';

var urls=setting.geturl();
var myfunction = {
	getDevice: function(data) {
		return request({
		    url: urls + 'Device',
		    method: 'get',
		    params: data
		});
	
	},		
    
	addDevice: function(data) {
		return request({
		    url: urls + 'Device/Add',
            method: 'post',
		    data: data
		});
	
	},    

    updateDevice: function(params, data) {
		return request({
		    url: urls + 'Device/Update',
            method: 'post',
            params: params,
		    data: data
		});
	
    },   
    
    deleteDevice: function(data) {
		return request({
		    url: urls + 'Device/Delete',
            method: 'post',
		    data: data
		});
    },    

    getFirmwareSummary: function(data) {
		return request({
		    url: urls + 'Firmware/GetSummary',
		    method: 'get',
		    params: data
		});
	
	},	

    getUserSummary: function(data) {
		return request({
		    url: urls + 'User/GetSummary',
		    method: 'get',
		    params: data
		});
	
	},	

	getUser: function(data) {
		return request({
		    url: urls + 'User/Get',
		    method: 'get',
		    params: data
		});
	
	},	

	createUser: function(params, data) {
		return request({
		    url: urls + 'User/Create',
            method: 'post',
            params: params,
		    data: data
		});
    },    

	createUserWithPer: function(params, data) {
		return request({
		    url: urls + 'User/CreateWithPermission',
            method: 'post',
            params: params,
		    data: data
		});
    },   	

	editUser: function(params, data) {
		return request({
		    url: urls + 'User/Edit',
            method: 'post',
            params: params,
		    data: data
		});
    },    

	editUserWithPer: function(params, data) {
		return request({
		    url: urls + 'User/EditWithPermission',
            method: 'post',
            params: params,
		    data: data
		});
    },   

	deleteUser: function(data) {
		return request({
		    url: urls + 'User/Delete',
		    method: 'get',
		    params: data
		});
	
	},

	getTrakerSummary: function(data) {
		return request({
		    url: urls + 'Tracker/GetSummary',
		    method: 'get',
		    params: data
		});
	},

	getTrackerSeries: function(data) {
		return request({
		    url: urls + 'Tracker/GetTrackerSeries',
		    method: 'get',
		    params: data
		});
	},

	getTrackerModels: function(data) {
		return request({
		    url: urls + 'Tracker/GetTrackerModels',
		    method: 'get',
		    params: data
		});
	},	

	getTracker: function(data) {
		return request({
		    url: urls + 'Tracker/Get',
		    method: 'get',
		    params: data
		});
	},		

	creatTracker: function(params, data) {
		return request({
		    url: urls + 'Tracker/Create',
            method: 'post',
            params: params,
		    data: data
		});
    }, 	

	editTracker: function(params, data) {
		return request({
		    url: urls + 'Tracker/Edit',
            method: 'post',
            params: params,
		    data: data
		});
    }, 		

	deleteTracker: function(data) {
		return request({
		    url: urls + 'Tracker/Delete',
		    method: 'get',
		    params: data
		});
	
	},	

	getTrackerMostFitOTAFiles: function(data) {
		return request({
		    url: urls + 'Tracker/GetTrackerMostFitOTAFiles',
		    method: 'get',
		    params: data
		});
	},	

	getOTAFilesByTracker: function(data) {
		return request({
		    url: urls + 'Tracker/GetOTAFilesByTracker',
		    method: 'get',
		    params: data
		});
	},		

	getTrackerGroup: function(data) {
		return request({
		    url: urls + 'TrackerGroup/GetBy',
		    method: 'get',
		    params: data
		});
	},		

	creatTrackerGroup: function(params, data) {
		return request({
		    url: urls + 'TrackerGroup/Create',
            method: 'post',
            params: params,
		    data: data
		});
    }, 	

	editTrackerGroup: function(params, data) {
		return request({
		    url: urls + 'TrackerGroup/Edit',
            method: 'post',
            params: params,
		    data: data
		});
    }, 		

	deleteTrackerGroup: function(data) {
		return request({
		    url: urls + 'TrackerGroup/Delete',
		    method: 'get',
		    params: data
		});
	
	},	
	
	removeTrackerInGroup: function(params, data) {
		return request({
		    url: urls + 'TrackerGroup/RemoveTracker',
            method: 'post',
            params: params,
		    data: data
		});
    }, 	
	
	AddTrackerInGroup: function(params, data) {
		return request({
		    url: urls + 'TrackerGroup/AddTracker',
            method: 'post',
            params: params,
		    data: data
		});
    }, 		

	postFileData: function(params, data) {
		return request({
		    url: urls + 'File/PostFileData',
            method: 'post',
            params: params,
		    data: data
		});
    }, 		
	
	postFiles: function(params, data) {
		return request({
		    url: urls + 'File/PostFiles',
            method: 'post',
            params: params,
		    data: data
		});
    }, 		

	getFile: function(data) {
		return request({
		    url: urls + 'File/Get',
		    method: 'get',
		    params: data
		});
	
	},	
	
	deleteFile: function(data) {
		return request({
		    url: urls + 'File/Delete',
		    method: 'get',
		    params: data
		});
	
	},		

	getTaskGetSummary: function(data) {
		return request({
		    url: urls + 'Task/GetSummary',
		    method: 'get',
		    params: data
		});
	
	},	

	createTask: function(params, data) {
		return request({
		    url: urls + 'Task/Create',
            method: 'post',
            params: params,
		    data: data
		});
    }, 		

	getTask: function(data) {
		return request({
		    url: urls + 'Task/Get',
		    method: 'get',
		    params: data
		});
	
	},	
	
	deleteTask: function(data) {
		return request({
		    url: urls + 'Task/Delete',
		    method: 'get',
		    params: data
		});
	
	},	

	cancelTask: function(data) {
		return request({
		    url: urls + 'Task/Cancel',
		    method: 'get',
		    params: data
		});
	
	},		

	getTaskTrackerStatus: function(data) {
		return request({
		    url: urls + 'Task/GetTrackerStatus',
		    method: 'get',
		    params: data
		});
	
	},	

	getMessage: function(data) {
		return request({
		    url: urls + 'Message/Get',
		    method: 'get',
		    params: data
		});
	
	},	
	
	confirmMessage: function(data) {
		return request({
		    url: urls + 'Message/MessageConfirmed',
		    method: 'get',
		    params: data
		});
	
	},	
	
	getMessageTypeCount: function(data) {
		return request({
		    url: urls + 'Message/GetMessageTypeCount',
		    method: 'get',
		    params: data
		});
	
	},		

	createMessage: function(params, data) {
		return request({
		    url: urls + 'Message/CreateBanch',
            method: 'post',
            params: params,
		    data: data
		});
    }, 	
	
	editMessage: function(params, data) {
		return request({
		    url: urls + 'Message/Edit',
            method: 'post',
            params: params,
		    data: data
		});
    }, 		

	deleteMessage: function(data) {
		return request({
		    url: urls + 'Message/Delete',
		    method: 'get',
		    params: data
		});
	
	},	
	
	getPermission: function(data) {
		return request({
		    url: urls + 'Permission/Get',
		    method: 'get',
		    params: data
		});
	
	},	
	
	createOrEditPermission: function(data) {
		return request({
		    url: urls + 'Permission/CreateOrEdit',
		    method: 'get',
		    params: data
		});
	
	},		

	download: function(page, url, filename) {
		page.axios({
			url: url,
			method: 'get',
			headers: {
				Authorization:'BasicAuth ' + localStorage.getItem('token')
			},
			responseType: 'blob'
		})            
		.then(res => {
			if(res.data.type){
				const blob = new Blob([res.data], {
					type: 'application/vnd.ms-excel'
				});
				let link = document.createElement('a');
				link.href = URL.createObjectURL(blob);
				link.setAttribute('download', filename + '.xls');
				link.click();
				link = null;
			} else {
				page.$message.warning(res.data.msg);
			}
		})
	
	},	
	
	downloadEx: function(page, url, filename) {
		page.axios({
			url: url,
			method: 'get',
			headers: {
				Authorization:'BasicAuth ' + localStorage.getItem('token')
			},
			responseType: 'blob'
		})            
		.then(res => {
			if(res.data.type){
				const blob = new Blob([res.data], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				});
				let link = document.createElement('a');
				link.href = URL.createObjectURL(blob);
				link.setAttribute('download', filename + '.xlsx');
				link.click();
				link = null;
			} else {
				page.$message.warning(res.data.msg);
			}
		})
	
	},	

	sendFOTAParam: function(params, data) {
		return request({
		    url: urls + 'Commander/SendFOTAParam',
            method: 'post',
            params: params,
		    data: data
		});
    }, 		
	
	getBaseInfo: function(data) {
		return request({
		    url: urls + 'User/GetUser',
		    method: 'get',
		    params: data
		});
	
	},	

	changePassword: function(data) {
		return request({
		    url: urls + 'User/ChangePassword',
		    method: 'get',
		    params: data
		});
	
	},	
	/**
	 * 批量创建设备（文件上传）
	 * @param {FormData} formData - 包含file, usersssid, groupsssid, trackerMode的FormData对象
	 * @returns {Promise}
	 */
	batchCreate: function(formData) {
		return request({
			url: urls + 'Tracker/BatchCreate',
			method: 'post',
			data: formData,
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	},
}

export default myfunction